import type { FlowScreenConfig } from "@/shared/constants/flowTypes";

import { AdminFormsLoadingScreen } from "../components/steps/AdminFormsLoadingScreen";

export function createAdminResultsScreens(): FlowScreenConfig[] {
  return [
    {
      id: "admin_forms_loading",
      layout: "full",
      hideButton: true,
      skipOnBack: true,
      customComponent: AdminFormsLoadingScreen,
    },
  ];
}
